import Firebase from 'firebase'

import firedux from '../firedux'

import {
  EXPERT_SESSION_REQUESTS_ENDPOINT,
  SESSION_REQUEST_STATUSES
} from '../../config/constants'

export default (expertUid, userUid, sessionLength) => {
  const ENDPOINT = `${EXPERT_SESSION_REQUESTS_ENDPOINT}/${expertUid}/${userUid}`

  firedux.ref.child(ENDPOINT).set({
    expert: expertUid,
    user: userUid,
    sessionLength,
    status: SESSION_REQUEST_STATUSES.REQUESTED,
    time: Firebase.ServerValue.TIMESTAMP
  })
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/request_immediate_session.js
 **/